<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-row>
            <b-col class="text-right">
              <router-link :to="{ name: 'EXCMUserDataWorkplaceCreate' }" class="btn btn-primary">{{ $t('buttons.create') }}</router-link>
            </b-col>
          </b-row>
          <b-card>
            <div class="card-body">
              <Loader v-if="isLoading" size="lg"></Loader>
              <template v-else>
                <div v-if="items.length > 0">
                  <table class="table table-sm table-striped table-hover">
                    <thead>
                    <tr>
                      <th>{{$t('views.excmuserdataworkplace.list.name')}}</th>
                      <th colspan="2" />
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                            v-for="item in items"
                            :key="item['@id']">
                      <td>
                        {{ item['title'] }}
                      </td>
                      <td>
                        <router-link
                                :to="{name: 'EXCMUserDataWorkplaceShow', params: { id: item['@id'] }}" class="float-right">
                          <button class="btn btn-link fa fa-search" v-b-tooltip.hover :title="$t('buttons.goto')" aria-hidden="true" />
                        </router-link>
                        <router-link :to="{name: 'EXCMUserDataWorkplaceUpdate', params: { id: item['@id'] }}" class="float-right">
                          <button class="btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
                        </router-link>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                <div v-if="view">
                  <pagination
                    :view="view"
                    @getPage="getPage($event)"
                  ></pagination>
                </div>
                  </div>
                <p v-else>{{ $t('views.excmuserdataworkplace.list.noworkplace') }}</p>
              </template>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import Pagination from '../../Layout/Pagination'

export default {
  components: {
    Loader,
    Pagination
  },

  computed: mapGetters({
    deletedItem: 'excmuserdataworkplace/del/deleted',
    error: 'excmuserdataworkplace/list/error',
    items: 'excmuserdataworkplace/list/items',
    isLoading: 'excmuserdataworkplace/list/isLoading',
    view: 'excmuserdataworkplace/list/view'
  }),

  data () {
    return {
      searchParams: {
        state: 1
      }
    }
  },

  created () {
    let url = addParamsToQuery('e_x_c_m_user_data_workplaces', this.searchParams)
    this.getPage(url)
  },

  methods: mapActions({
    getPage: 'excmuserdataworkplace/list/default'
  })
}
</script>
